module.exports = __webpack_public_path__ + "static/media/aUSDO.a0f4116e.svg";